import { RouteConfig } from 'vue-router';

const PAGE_TITLE = '';
const baseUrl = '20260525SQFLZCZN';

const route: RouteConfig = {
  path: `/${baseUrl}`,
  name: baseUrl,
  component: () => import('./ViewHolder.vue'),
  redirect: `/${baseUrl}/home`,
  meta: {
    title: PAGE_TITLE,
  },
  children: [
    {
      path: 'home',
      name: `${baseUrl}-home`,
      component: () => import('./pages/Home.vue'),
      meta: {
        title: PAGE_TITLE,
        keepAlive: true,
      },
    },
    {
      path: 'reader',
      name: `${baseUrl}-reader`,
      component: () => import('./pages/Reader.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
  ],
};

export default route;
